var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"inline-block rounded-full text-center overflow-hidden can-hover:hover:shadow active:shadow select-none",class:_vm.className,attrs:{"type":"button"},on:{"click":_vm.click}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }